import {
  RemoteData,
  remoteDataError,
  remoteDataLoading,
  remoteDataNotFetched,
  remoteDataOK,
} from '@common/util-models';
import { EntityAdapter, EntityState, createEntityAdapter } from '@ngrx/entity';
import {
  BundleApplianceDetailsBasket,
  SkyMobilePriceConfig,
} from '@sky/util-models';

import { createReducer, on } from '@ngrx/store';
import * as DevicesActions from './devices.actions';

export const DEVICES_FEATURE_KEY = 'devices';
export const SKY_ESSENTIAL_IDENTIFIER = 'VIRTUAL';
export const SKY_ESSENTIAL_VIP_IDENTIFIER = 'Q+_VIP';

export interface DevicesState
  extends EntityState<BundleApplianceDetailsBasket> {
  remoteState: RemoteData<null>;
  isSkyEssential: boolean;
  skyMobilePriceConfig?: SkyMobilePriceConfig[];
}

export interface DevicesPartialState {
  readonly [DEVICES_FEATURE_KEY]: DevicesState;
}

export const devicesAdapter: EntityAdapter<BundleApplianceDetailsBasket> =
  createEntityAdapter<BundleApplianceDetailsBasket>({
    selectId: (device) => device.applianceId,
  });

export const initialDevicesState: DevicesState = devicesAdapter.getInitialState(
  {
    remoteState: remoteDataNotFetched(),
    isSkyEssential: false,
  }
);

export const devicesReducer = createReducer(
  initialDevicesState,

  on(DevicesActions.removeAll, (state) => {
    return devicesAdapter.removeAll({
      ...state,
      remoteState: remoteDataNotFetched(),
    });
  }),

  on(DevicesActions.addDevicesToBasket, (state) => ({
    ...state,
    remoteState: remoteDataLoading(),
  })),

  on(DevicesActions.addDevicesToBasketSuccess, (state, { devices }) =>
    devices.length &&
    devices[0].applianceCode !== SKY_ESSENTIAL_IDENTIFIER &&
    devices[0].applianceCode !== SKY_ESSENTIAL_VIP_IDENTIFIER
      ? devicesAdapter.addMany(devices, {
          ...state,
          isSkyEssential: false,
          remoteState: remoteDataOK(null),
        })
      : {
          ...state,
          isSkyEssential: true,
          skyMobilePriceConfig: devices.length
            ? devices[0].skyMobilePriceConfig
            : [],
        }
  ),

  on(DevicesActions.addDevicesToBasketFailure, (state, { error }) => ({
    ...state,
    remoteState: remoteDataError(error),
  })),

  on(DevicesActions.deleteDevicesFromBasket, (state) => ({
    ...state,
    remoteState: remoteDataLoading(),
  })),

  on(DevicesActions.deleteDevicesFromBasketSuccess, (state, { deviceIds }) => {
    return devicesAdapter.removeMany(deviceIds, {
      ...state,
      remoteState: remoteDataOK(null),
    });
  }),

  on(DevicesActions.deleteDevicesFromBasketFailure, (state, { error }) => ({
    ...state,
    remoteState: remoteDataError(error),
  }))
);
